import { IMAGES } from "../../data/content";

export const Navbar = () => (
  <header
    data-testid="main-navbar"
    className="fixed top-0 inset-x-0 z-50 bg-white/90 backdrop-blur-xl border-b border-zinc-200"
  >
    <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
      <img
        src={IMAGES.brdLogo}
        alt="BRD Groupe Société Générale"
        data-testid="navbar-brd-logo"
        className="h-8 md:h-9 w-auto"
      />
      <img
        src={IMAGES.isicLogo}
        alt="ISIC — International Student Identity Card"
        data-testid="navbar-isic-logo"
        className="h-8 md:h-9 w-auto"
      />
    </div>
  </header>
);
